// App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { lightTheme, darkTheme } from './themes';
import MainScreen from './screens/MainScreen';
import SubscriptionScreen from './screens/SubscriptionScreen';
import PaymentScreen from './screens/PaymentScreen';
import SubscriptionsManagement from './screens/SubscriptionsManagement';
import SuccessScreen from './screens/SuccessScreen';
import RaffleScreen from './screens/RaffleScreen'; 
import Partnership from './screens/Partnership';

// Global Styles
const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    background-color: ${props => props.theme.background};
    color: ${props => props.theme.text};
    transition: all 0.3s ease;
  }
  * {
    box-sizing: border-box;
  }
`;

// Mock data for VPN types
const vpnTypes = [
  // { id: 'outline', name: 'Outline', description: 'Менее стабилен' },
  { id: 'v2ray', name: 'Базовый', description: 'Безлимит (WIFI)' },
  { id: 'v2raybypass', name: 'Обход глушилок', description: '200 Гб (WIFI+LTE)' },
];

// Mock prices
const prices = {
  outline: { '1': 199, '3': 499 },
  v2ray: { '1': 199, '3': 499 },
  v2raybypass: { '1': 299, '3': 750 },
};

// Mock subscriptions for management screen
const mockSubscriptions = [
  { id: 1, type: 'Outline', months: 1, endDate: '2026-01-24', status: 'active' },
  { id: 2, type: 'V2Ray', months: 3, endDate: '2025-12-01', status: 'expired' },
];

function App() {
  const [theme, setTheme] = useState(lightTheme);
  const [selectedVPN, setSelectedVPN] = useState(null);
  const [selectedMonths, setSelectedMonths] = useState('1');
  const [promoCode, setPromoCode] = useState('');
  const [appliedPromo, setAppliedPromo] = useState(false);
  const [vpnKey, setVpnKey] = useState('');

  useEffect(() => {
    if (window.Telegram && window.Telegram.WebApp) {
      const tg = window.Telegram.WebApp;
      tg.ready();
      tg.expand();

      // Set theme based on Telegram
      const tgTheme = tg.themeParams;
      const isDark = tg.colorScheme === 'dark';
      setTheme(isDark ? darkTheme : lightTheme);

      // Listen for theme changes
      tg.onEvent('themeChanged', () => {
        setTheme(tg.colorScheme === 'dark' ? darkTheme : lightTheme);
      });
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router>
        <Routes>
          <Route path="/" element={<MainScreen setSelectedVPN={setSelectedVPN} vpnTypes={vpnTypes} />} />
          <Route path="/subscription" element={<SubscriptionScreen 
            selectedVPN={selectedVPN} 
            prices={prices} 
            selectedMonths={selectedMonths} 
            setSelectedMonths={setSelectedMonths}
            vpnTypes={vpnTypes}
            promoCode={promoCode}
            setPromoCode={setPromoCode}
            appliedPromo={appliedPromo}
            setAppliedPromo={setAppliedPromo}
          />} />
          <Route path="/gift" element={<RaffleScreen telegramId={window.Telegram?.WebApp?.initDataUnsafe?.user?.id || null} />} />
          <Route path="/partnership" element={<Partnership />} />
          <Route path="/payment" element={<PaymentScreen 
            selectedVPN={selectedVPN} 
            selectedMonths={selectedMonths} 
            prices={prices}
            promoCode={promoCode}
            appliedPromo={appliedPromo}
          />} />
          <Route 
            path="/management" 
            element={
              <SubscriptionsManagement 
                setSelectedVPN={setSelectedVPN}
                setSelectedMonths={setSelectedMonths}
                vpnTypes={vpnTypes} 
              />
            } 
          />
          <Route path="/success" element={<SuccessScreen vpnKey={vpnKey} setVpnKey={setVpnKey} selectedVPN={selectedVPN} />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;